import Widget from '@/plugins/dashboard/widgets/Weight/Widget'
import Configure from '@/plugins/dashboard/widgets/Weight/Configure'
import Chart from '@/plugins/dashboard/classes/Chart'

export default class extends Chart {
  static name = 'Weight'
  static widget = Widget
  static configure = Configure
}
